const SOLO_DIA = /^\d{4}-\d{2}-\d{2}$/

/**
 * Returns the calendar day, as YYYY-MM-DD, of a date that a timestamptz column stores at midnight UTC.
 * A YYYY-MM-DD string is returned as is.
 * The day is the UTC day of the instant, so the offset in the string does not change it.
 * A null, empty or invalid value returns null.
 */
export const diaCalendario = (valor: string | null | undefined): string | null => {
  if (!valor) return null
  if (SOLO_DIA.test(valor)) return valor
  const instante = new Date(valor)
  return Number.isNaN(instante.getTime()) ? null : instante.toISOString().slice(0, 10)
}

/**
 * Returns the calendar day of the value as dd/MM/yyyy, or null when diaCalendario returns null.
 * It builds the text from the YYYY-MM-DD string, so the browser time zone does not change it.
 */
export const formatearDiaCalendario = (valor: string | null | undefined): string | null => {
  const dia = diaCalendario(valor)
  if (!dia) return null
  const [anio, mes, diaDelMes] = dia.split('-')
  return `${diaDelMes}/${mes}/${anio}`
}
